export enum ConceptualKeys {
  Sources = 'sources',
  Definition = 'definition',
  Measurement = 'measurement',
  JustificationStatement = 'justification_statement',
}
